// src/app/directives/phone-validator.directive.ts
import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { ValidationUtils } from '../Util/validation.utils';

@Directive({
  selector: '[phoneValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: PhoneValidatorDirective,
    multi: true
  }]
})
export class PhoneValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value) return null; // let 'required' handle empty

    const isValid = ValidationUtils.isValidPhone(control.value);
    return isValid ? null : { phone: true }; // error key: 'phone'
  }
}